import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.dimensionData`;
export const BENCHMARK_SCOPE = `${PARENT_SCOPE}.benchmarkData`;
export const INIT = `${SCOPE}/INIT`;

export const INIT_DIMENSION = `${SCOPE}/INIT_DIMENSION`;
export const SETUP_DIMENSION = `${SCOPE}/SETUP_DIMENSION`;
export const SET_LOADING_STATE = `${SCOPE}/SET_LOADING_STATE`;
export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;

export const SET_DIMENSION = `${SCOPE}/SET_DIMENSION`;
export const UNSET_DIMENSION = `${SCOPE}/UNSET_DIMENSION`;
export const SET_RESPONSE = `${SCOPE}/SET_RESPONSE`;
export const SET_BENCHMARK_RESPONSE = `${BENCHMARK_SCOPE}/SET_BENCHMARK_RESPONSE`;
